/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { productLinesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsProductLines";
import getColor from "@insite/mobius/utilities/getColor";
import { imageHoverEffect } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

productLinesStyles.title = {
    variant: "h3",
    lineHeight: "30px",
    color: "secondary.main",
};

productLinesStyles.container = {};

productLinesStyles.productLineContainer = {
    gap: 15,
};

productLinesStyles.productLineImageClickable = {
    css: css`
        &,
        > * {
            width: 100%;
        }
    `,
};

productLinesStyles.productLineImageItem = {
    width: 12,
    css: css`
        &&& {
            margin-bottom: 15px;
        }
    `,
};

productLinesStyles.productLineImage = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        border: 1px solid ${getColor("common.ui12")};
        background: ${getColor("common.background")};
        height: 126px;
        overflow: hidden;
        width: 100%;

        img {
            object-fit: cover;
            object-position: center center;
            height: 100%;
        }

        ${imageHoverEffect};

        &:hover,
        &:focus {
            &:after {
                opacity: 1;
            }
        }
    `,
};

productLinesStyles.productLineNameLinkItem = {
    width: 12,
    css: css`
        &&& {
            text-align: center;
            justify-content: center;
        }
    `,
};

productLinesStyles.productLineNameLink = {
    typographyProps: {
        size: "16px",
        weight: 700,
        lineHeight: "22px",
    },
};

productLinesStyles.productLineItemRow = {
    width: [12, 6, 4, 3, 2],
    css: css`
        padding-bottom: 30px;
    `,
};

productLinesStyles.innerProductLineContainer = {
    gap: 0,
    css: css`
        &&& {
            width: 100%;
        }
    `,
};
